import {
  EncumbranceEntity,
  PropertyEntity,
  PropertyRightEncumbrancePriorityEntity,
} from '../entities/app-base-property';
import { PropertyOwnersParams, PropertyRightEncumbranceCompositeEntity } from '../extensions/app-extensions';
import { PropertyRightTypeKey } from '../entities/app-dim-property';

export function isPropertyRightEncumbrancePriorityEntity(
  item: unknown,
): item is PropertyRightEncumbrancePriorityEntity {
  return (
    !!item &&
    item.hasOwnProperty('property_right_uuid') &&
    item.hasOwnProperty('encumbrance_uuid') &&
    item.hasOwnProperty('date_priority') &&
    item.hasOwnProperty('registered_priority') &&
    item.hasOwnProperty('calculated_priority') &&
    item.hasOwnProperty('calculated_priority_origin_key')
  );
}

export function hasPropertyEntity<T>(item: T): item is T & { property: PropertyEntity } {
  return !!item && item.hasOwnProperty('property');
}

export function hasPropertyOwnersParams<T>(item: T): item is T & PropertyOwnersParams {
  return !!item && item.hasOwnProperty('propertyUuid');
}

export function isPropertyRightTypeKey(item: unknown): item is PropertyRightTypeKey {
  return Boolean(PropertyRightTypeKey[item as PropertyRightTypeKey]);
}

export function isPropertyRightEncumbranceCompositeEntity(
  item: unknown,
): item is PropertyRightEncumbranceCompositeEntity {
  return !!item && item.hasOwnProperty('encumbrance') && item.hasOwnProperty('property_right_encumbrance');
}

export function isEncumbranceEntity(item: unknown): item is EncumbranceEntity {
  return (
    !!item &&
    item.hasOwnProperty('encumbrance_key') &&
    item.hasOwnProperty('encumbrance_context') &&
    item.hasOwnProperty('business_key')
  );
}
